<template>

<div id="ultim_tab" class="flex_content" v-if="currentEval.saven_test">

    <div class="container">

        <div class="ultim_scores_container">


            <UltimScores :scores_data="currentEval.saven_test.ultim_data" />


        </div>

    </div>
</div>

</template>

<script>
    
    import AnimatedNumber from "animated-number-vue";
    import UltimScores from '../scores/ultimScores'
    

    export default {
        name: 'UltimTab',
        components: {
            AnimatedNumber,
            UltimScores
        },
        mounted() {
            
        },
        data(){
            return {
               
            }
        },
        computed: {
            currentEval(){
                return this.$store.state.EvalStore.currentEval
            }
        },
        methods: {
            
        }
    }
</script>

<style lang="scss" scoped>

</style>